import React from "react";
import PageHero from "../components/PageHero";
import Infrastructure from "../components/Infrastructure";
import CampusLife from "../components/CampusLife";
import Ecosystem from "../components/Ecosystem";
import { campusMoments } from "../mock/pages";
import { SectionHeading } from "../components/SectionHeading";
import useSeo from "../hooks/useSeo";
import CtaBand from "../components/CtaBand";

export default function CampusPage() {
  useSeo({
    title: "Campus & Infrastructure",
    path: "/campus",
    description:
      "Explore The KPR Academy's 160+ acre Coimbatore campus — smart classrooms, science and AI labs, robotics studio, central library, auditorium, indoor arena, 400m athletics track, swimming complex, art and music studios, dining hall and GPS-tracked transport.",
    keywords:
      "KPR Academy campus, school infrastructure Coimbatore, CBSE school facilities, school sports facilities Coimbatore, robotics lab school, swimming pool school Coimbatore",
  });

  return (
    <>
      <PageHero
        eyebrow="Campus & Infrastructure"
        title="One campus — the facilities and the life inside them"
        sub="Labs, arenas, studios and libraries built to college-grade standards, and a week of clubs, assemblies, sport and celebration that puts them to use."
        crumbs={[{ label: "Campus & Infrastructure" }]}
        image="/campus/school-2.jpg"
      />

      <Infrastructure />
      <CampusLife />

      <section className="py-24 lg:py-28" style={{ background: "var(--cream)" }}>
        <div className="mx-auto max-w-[1280px] px-5 lg:px-6">
          <SectionHeading
            eyebrow="A week on campus"
            title="Six things that happen here every single week"
            align="center"
          />
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {campusMoments.map((m, i) => (
              <div
                key={m.title}
                data-reveal=""
                style={{ transitionDelay: `${i * 80}ms`, border: "1px solid rgba(11,59,54,.09)" }}
                className="rounded-2xl bg-white p-7"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = "0 28px 55px -38px rgba(8,46,41,.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <span className="font-display text-[1.6rem]" style={{ color: "rgba(192,138,46,.35)" }}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display mt-3 text-[1.2rem]" style={{ color: "var(--teal-900)" }}>
                  {m.title}
                </h3>
                <p className="mt-2.5 text-[0.88rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
                  {m.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
      <Ecosystem />
    </>
  );
}
